import Form from '../jobs/components/form/Form.vue';
import Item from '../jobs/components/item/Item.vue';
import StatusIcon from './StatusIcon.vue';

export default {
  name: 'AboutPage',
  components: { Form, Item, StatusIcon },
  data() {
    return {
      editItem: {},
      showDialogItem: false,
      showDialog: false,
      page: 1,
      edit: false,
      edit2: false,
      portfolio_description: '',
      editTypes: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    status_items() {
      return this.user.portfolio_status.items;
    },
    items() {
      return this.$store.state.portfolio.items;
    },
    types() {
      const items = this.$store.state.jobs.types.map(el => ({
        ...el,
        is_checked: this.receivedJobTypes.find(item => el.id === item.id),
      }));
      return items;
    },
    /** Специализации */
    specializations() {
      const items = this.$store.state.specializations.items.map(el => ({
        ...el,
        is_checked: this.receivedSpecializations.find(
          item => el.id === item.id,
        ),
      }));

      return items;
    },
    /** Полученные специализации */
    receivedSpecializations() {
      return this.$store.state.specializations.myItems;
    },

    /** Полученные Типы работ */
    receivedJobTypes() {
      return this.user.job_types || [];
    },
  },
  methods: {
    getStatusItem(statusItem) {
      return this.status_items.find(el => el.name === statusItem);
    },
    EditItem(item) {
      this.editItem = item;
      this.showDialogItem = true;
    },
    saveDescription() {
      this.$store.getters.axl
        .post('profiles/api/profiles/change-portfolio', {
          portfolio_description: this.portfolio_description,
          job_types_ids: this.types
            .filter(el => el.is_checked)
            .map(el => el.id),
        })
        .then((response) => {
          this.$store.dispatch('GetProfile');
          this.$store.dispatch('ShowInfo', response.data.msg);
          this.edit = false;
          this.edit2 = false;
        })
        .catch((error) => {
          this.$store.dispatch('HandleError', error);
        });
    },
    setTitle() {
      const status = this.user.portfolio_status;
      const statusClassAsso = {
        new: 'new',
        admin_review: 'admin-review',
        success: 'portfolio-success',
        blocked: 'blocked',
      };
      this.$store.dispatch(
        'SetTitle',
        `<div style='display: flex; justify-content: flex-start'>
                <span style="flex-grow: unset">Портфолио</span>
                <div class="${
  statusClassAsso[status.status]
} new portfolio-status">${status.label}</div>
            </div>`,
      );
    },
  },
  mounted() {
    this.setTitle();
    this.$store.dispatch('specializations/GetList');
    this.$store.dispatch('specializations/GetMy');
    this.$store.dispatch('portfolio/GetList', {
      owner_id: this.user.profile_id,
    });
    this.$store.dispatch('jobs/GetTypes');
    this.portfolio_description = this.user.portfolio_description;
  },
};
